<template lang="pug">
  div
    content-loader(:height="7", v-if="alert.loading")
    div(v-else-if="rentals && rentals.length > 0")
      b-card.table-card
        p(v-if='rentals.length < 1') No rentals
        b-table(v-else="", :items="rentals", :fields="fields", sort-icon-left, sort-by="status", :sort-desc="true", responsive, borderless, hover)
          template(v-slot:cell(compStatus)="row")
            b-badge {{ row.item.status.toUpperCase() }}
          template(v-slot:cell(compTrack)="row")
            a.text-primary(:href="`https://optimise.parcelninja.com/shipment/track/${row.item.return_shipment_tracking_number}`", target="_blank") {{ row.item.return_shipment_tracking_number || 'TBA'}}
      p.mt-3 These pieces will be automatically be re-activated in your gallery once returned
    nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import Vue from 'vue';

export default {
  name: 'Rental',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      rentals: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'art_title', label: 'Piece' },
        { key: 'compStatus', label: 'Status' },
        { key: 'compTrack', label: 'Track' },
      ],
    };
  },
  computed: {
    totalRows() {
      return this.rentals.length;
    },
  },
  methods: {
    async confirmReturn(rental) {
      const thisRental = rental;
      Vue.set(thisRental, 'busy', true);
      try {
        this.busy();
        await apiService.confirmReturn(rental.id);
        this.rentals = this.rentals.filter(item => item.id !== rental.id);
        this.clear();
      } catch (error) {
        thisRental.busy = false;
        this.error('Could not confirm item');
      }
    },
    refreshData() {
      const d = new Date();
      this.lastUpdate = `${d.getUTCHours() + 2}:${d.getUTCMinutes()}:${d.getUTCSeconds()}`;
      this.getResource('races');
    },
  },
  async created() {
    this.loading();
    this.rentals = await apiService.getRentals(this.profileId, 'returning');
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/RentalsReturned.vue